﻿import Image from "../image";
import ActivePage from "../activePage";

export default class DisclosurePage extends ActivePage {

    constructor() {
        super();
        this.image = new Image();
        this.showOutstandingActionsOnly = true;

        this.checkWorkflowActions = false;
        this.workflowTriggerType = "";
    }

    init(screen) {
        $(document).ready(() => {            

            const inventorsGrid = $(`#inventorsGrid_${screen}`);
            inventorsGrid.on("click", ".inventorLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = inventorsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.InventorDetail.InventorID);
                pageHelper.openLink(linkUrl, false);
            });  

            const atty = this.getKendoComboBox("AttorneyID");            
            $("input[name='ClientID']").change(function () {
                const baseUrl = $("body").data("base-url");
                $.ajax({
                    url: `${baseUrl}/Shared/Client/GetPatDefaultAttorney`,
                    data: { clientId: this.value },
                    dataType: 'json',
                    success: function (data) {
                        if (data.length > 0) {
                            if (atty.value() == '' && data[0].PatAttorney1ID != null) {
                                atty.value(data[0].PatAttorney1ID);
                                atty.element.trigger("change");
                            }                            
                        }
                    }
                });
            })                      
        });
    }

    tabChangeSetListener() {
        $('#disclosureTab a').on('click', (e)=> {
            e.preventDefault();
            const tab = e.target.id;
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);
                this.loadTabContent(tab);
            }
        });

        this.disclosureSetListener();
    }

    disclosureSetListener() {
        let form = $("#dmsDiclosureDetail-Content").find("form")[0];
        form = $(form);

        //let triggers = ["ClearanceStatus"];
        //let dateFields = "";
        //triggers.forEach(function (item) {
        //    const field = `,input[name="${item}"]`;
        //    dateFields += field;
        //});

        let triggers = ["DisclosureStatus"];
        let nonDateFields = "";
        triggers.forEach(function (item) {
            const field = `,input[name="${item}"]`;
            nonDateFields += field;
        });

        const self = this;
        $(document).ready(function () {
            //form.find(dateFields.substr(1)).each(function () {
            //    const datePicker = $(this).data("kendoDatePicker");
            //    if (datePicker) {
            //        datePicker.bind("change", function () {
            //            self.computeTaxStartExpiration = true;
            //        });
            //    }
            //});
            form.find(nonDateFields.substr(1)).each(function () {
                $(this).bind("change", function () {
                    self.checkWorkflowActions = true;
                    self.workflowTriggerType = "status";
                });
            });
        });

    }

    //called also after save (update and insert)
    showDetails(id) {
        const self = this;
        pageHelper.showDetails(this, id, function () {
            if (self.checkWorkflowActions) {
                self.checkWorkflowActions = false;
                self.checkDisclosureWorkflow(id, self.workflowTriggerType);
                self.workflowTriggerType = "";
            }
        });
    }

    deleteDueDate = (e, grid, deleteActionDuePrompt) => {
        this.deleteGridRow(e, grid);
    }

    loadTabContent(tab) {
        const self = this;
        
        switch (tab) {
            case "actionTab":
                $(document).ready(() => {
                    const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    $(".grid-options #showOutstandingActionsOnly").prop('checked', this.showOutstandingActionsOnly);
                    if (parseInt(grid.options.dataSource.pageSize) > 0)
                        grid.dataSource.pageSize(grid.options.dataSource.pageSize);
                    else
                        grid.dataSource.read();
                });
                break;
            
            case "keywordsTab":
                $(document).ready(function () {
                    const grid = $("#keywordsGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "disclosureDetailDocumentsTab":
                $(document).ready(()=> {
                    this.image.initializeImage(this);
                });
                break;
            case "reviewsTab":
                $(document).ready(function () {
                    const grid = $("#reviewsGrid").data("kendoGrid");
                    grid.dataSource.read();
                    //use reviewsGridDataBound to also initialize rating when sorting
                    //.done(function () {
                    //    $("#reviewsGrid").find(".star-rating").rating(disclosureReviewPage.getRatingOptions());
                    //});
                });
                break;

            case "relatedInventionTab":
                $(document).ready(function () {
                    const grid = $("#relatedInventionGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "relatedApplicationTab":
                $(document).ready(function () {
                    const grid = $("#relatedApplicationGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "disclosureDetailDiscussionsTab":
                $(document).ready(function () {
                    const grid = $("#disclosureDiscussionGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "disclosureDetailCorrespondenceTab":
                $(document).ready(() => {
                    const grid = $(`#docsOutGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    grid.dataSource.read();                    
                });
                break;
            
            case "":
                break;
        }

        // questionnaire tab
        const questionTabs = $("#questionTabs").val().split("|").filter(item => item === tab);
        if (questionTabs.length) {
            const gridName = `#${questionTabs[0]}Grid_${this.mainDetailContainer}`;
            const grid = $(gridName).data("kendoGrid");
            grid.dataSource.read();
            //prevent click outside the input box
            grid.table.on("click", ".answer-box", function () {
                return false;
            });
        }
        
    }

    reviewsGridDataBound(e) {
        //READONLY REVIEWS GRID
        let ratingOptions = disclosureReviewPage.getRatingOptions();
        ratingOptions.displayOnly = true;
        $("#reviewsGrid").find(".star-rating").rating(ratingOptions);
    }

    setSubmitButton(submitTitle, submitMessage) {
        const button = $("#submitDisclosure");
        if (button) {
            button.on("click", (e) => {
                cpiConfirm.confirm(submitTitle, submitMessage, function () {
                    const url = button.data("url");
                    const data = {};
                    data.id = $("#DMSId").val();
                    data.tStamp = $("#tStamp").val();

                    $.ajax({
                        url: url,
                        data: data,
                        type: "POST",
                        headers: { "RequestVerificationToken": $("[name='__RequestVerificationToken']").val() },
                        success: function (result) {
                            disclosurePage.showDetails(data.id);
                            pageHelper.showSuccess(result.success);
                            // send email, if required
                            if (result.sendEmail) {
                                disclosurePage.sendSubmissionEmail(data.id, result.isAutoEmail);
                            }
                            if (result.checkWorkflow) {
                                disclosurePage.checkDisclosureWorkflow(data.id, "status");
                            }
                        },
                        error: function (error) {
                            pageHelper.showErrors(error.responseText);
                        }

                    });

                });
            });
        }
    }

    sendSubmissionEmail(dmsId, isAutoEmail) {
        const parent = $("#disclosureParameters");
        const url = parent.data("submission-email-url");
        const data = { dmsId: dmsId };
        $.ajax({
            url: url,
            type: "GET",
            data: data,
            success: function (result) {
                if (!isAutoEmail) {
                    const popupContainer = $(".cpiContainerPopup").last();
                    popupContainer.html(result);
                    const dialog = $("#quickEmailDialog");
                    dialog.modal("show");
                }
                else {
                    pageHelper.showSuccess(result.success);
                }
            },
            error: function (error) {
                pageHelper.showErrors(error);
            }
        });
    }

    // ------------------------------ inventor logic
    
    onEditInventor(e) {
        const gridId = e.sender.element[0].id;
        if (e.model.isNew()) {
            //Remove move class on newly added row as we do not want to move record which is not yet saved.
            $("#" + gridId + " tbody").find("tr[data-uid=" + e.model.uid + "]").css({ 'cursor': "default", 'HintHandler': '' });
            $("#" + gridId + " tbody").find("tr[data-uid=" + e.model.uid + "]").removeAttr("onChange");
        }
    }

    inventorGridDataBound = function (e) {
        const gridId = e.sender.element[0].id;
        const grid = $("#" + gridId).data("kendoGrid");
        const data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            const trow = grid.tbody.find("tr[data-uid='" + data[i].uid + "']");
            //window.fely = trow;
            if (!data[i].CanModifyName && !data[i].CanModifyInitials) {
                trow.addClass("read-only");
            }
            else if (!data[i].CanModifyName) {
                trow.children("td.editable-cell.inventor-cell").removeClass("editable-cell");
            }
            else if (!data[i].CanModifyInitials) {
                trow.children("td.editable-cell.initials-cell").removeClass("editable-cell");
            }
            if (data[i].IsDefaultInventor) {
                trow.find(".k-grid-Delete").hide();
            }
        }
    }

    isInventorInitialEditable(dataItem) {
        return dataItem.CanModifyInitials;
    }

    isInventorNameEditable(dataItem) {
        return dataItem.CanModifyName;
    }

    // ------------------------------ question logic
    questionGridDataBound = function (e) {
        const gridId = e.sender.element[0].id;
        const grid = $("#" + gridId).data("kendoGrid");
        const data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            const trow = grid.tbody.find("tr[data-uid='" + data[i].uid + "']");
            if (!data[i].CanEdit) {
                trow.children("td.editable-cell.text-answer-cell").removeClass("editable-cell");
                trow.children("td.editable-cell.date-answer-cell").removeClass("editable-cell");
                trow.children("td.editable-cell.yesno-answer-cell")[0].innerHTML = "";
                trow.children("td.editable-cell.yesno-answer-cell").removeClass("editable-cell");
            }
            else {
                if (!data[i].IsAnswerText) {
                    trow.children("td.editable-cell.text-answer-cell").removeClass("editable-cell");
                }
                if (!data[i].IsAnswerDate) {
                    trow.children("td.editable-cell.date-answer-cell").removeClass("editable-cell");
                }
                if (!data[i].IsAnswerYesNo) {
                    trow.children("td.editable-cell.yesno-answer-cell")[0].innerHTML = "";
                    trow.children("td.editable-cell.yesno-answer-cell").removeClass("editable-cell");
                    //trow.children("td.editable-cell.yesno-answer-cell").hide();
                }
            }
            
            
        }
    }

    isTextQuestionEditable(dataItem) {
        return dataItem.IsAnswerText;
    }

    isDateQuestionEditable(dataItem) {
        return dataItem.IsAnswerDate;
    }

    isYesNoQuestionEditable(dataItem) {
        return dataItem.IsAnswerYesNo;
    }

    //called on inventor grid's afterSubmit to refresh inventor-based detail page permissions
    refreshDetail = () => {
        disclosurePage.showDetails(this.currentRecordId);
    }

    //inventor grid delete handler that calls refreshDetail after delete
    //delete button is disabled when grid is dirty
    //if delete is allowed if there are pending updates, it will be lost when refreshDetail is called
    deleteInventorRow(e, grid) {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        this.addMoreKeyFields(dataItem);

        const self = this;
        //pageHelper.deleteGridRow(e, dataItem, function () { self.updateRecordStamps(); });
        pageHelper.deleteGridRow(e, dataItem, function () { self.refreshDetail(); });
    }


    refreshDiscussionGrid(e) {
        //const gridId = e.sender.element[0].id;
        $("#disclosureDiscussionGrid").data("kendoGrid").dataSource.read();
    }

    discussionDataBound(e) {
        const gridId = e.sender.element[0].id;
        const grid = $("#" + gridId).data("kendoGrid");
        const data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            const trow = grid.tbody.find("tr[data-uid='" + data[i].uid + "']");
            if (!data[i].CanDelete) {
                trow.find(".k-grid-delete").hide();
            }
            else if (data[i].CanDelete && data[i].CanEditRecord) {
                trow.find(".k-grid-delete").show();
            }
            else {
                trow.find(".k-grid-delete").hide();
            }

            if (!data[i].CanEdit) {
                trow.find(".k-grid-edit").hide();
            }
            else if (data[i].CanEdit && data[i].CanEditRecord) {
                trow.find(".k-grid-edit").show();
            }
            else {
                trow.find(".k-grid-edit").hide();
            }
        }
    }

    onDiscussionEdit(e) {
        var arg = e;
        arg.container.data('kendoWindow').bind('activate', function () {
            arg.container.find("textarea[name='DiscussionMsg']").focus();
        })
    }

    onDiscussionRequestEnd(e) {
        //type: create, update, destroy
        //if type is create - check workflow for new discussion
        if (e.type === "create") {
            disclosurePage.checkDisclosureWorkflow(e.response.dmsId, "discussion");
        }
    }

    replyRequestEnd(e) {
        if (e.type == "destroy") {
            $("#disclosureDiscussionGrid").data("kendoGrid").dataSource.read();
        }
        if (e.type === "create") {
            disclosurePage.checkDisclosureWorkflow(e.response.dmsId, "reply");
        }
    }

    // ---------------------------- workflow
    checkDisclosureWorkflow(id, triggerType) {
        let mainForm = $(`#${this.mainDetailContainer}`).find("form")[0];
        mainForm = $(mainForm);
        const url = mainForm.data("check-workflow");
        const data = { dmsId: id, triggerType: triggerType };
        $.ajax({
            url: url,
            data: data,
            type: "POST",
            headers: { "RequestVerificationToken": $("[name='__RequestVerificationToken']").val() },
            success: function (result) {
                if (result.qeSetupIds && result.sendEmail) {
                    var qeSetupIds = JSON.parse(result.qeSetupIds);                    
                    for (var i = 0; i < qeSetupIds.length; i++) {
                        var qeSetupId = qeSetupIds[i];
                        //disclosurePage.sendQuickEmail(data.dmsId, true, "auto-email-url", qeSetupId, true); 
                        disclosurePage.sendQuickEmail(data.dmsId, !qeSetupId.Item2, "auto-email-url", qeSetupId.Item1, !qeSetupId.Item2);                          
                    }
                }
            },
            error: function (error) {
                pageHelper.showErrors(error.responseText);
            }
        });
    }

    sendQuickEmail(dmsId, isAutoEmail, urlName, qeSetupId, sendImmediately) {
        const parent = $("#disclosureParameters");        
        const url = parent.data(urlName);
        const data = { dmsId: dmsId, qeSetupId: qeSetupId, sendImmediately: sendImmediately };
        $.ajax({
            url: url,
            type: "GET",
            data: data,
            success: function (result) {
                if (!isAutoEmail) {
                    const popupContainer = $(".cpiContainerPopup").last();
                    popupContainer.html(result);
                    const dialog = $("#quickEmailDialog");                
                    dialog.modal("show"); 

                    //dialog.on('hidden.bs.modal', function (event) {
                    //    myResolve(true);                           
                    //});  
                }
                else {
                    //pageHelper.showSuccess(result.success);
                }
            },
            error: function (error) {
                pageHelper.showErrors(error);
            }
        });
    }
}


